<template>
  <div class="w-full bg-legal">
    <div class="py-20 px-4 lg:px-24">
      <h1 class="font-benzin text-white text-4xl uppercase tracking-wide font-normal mt-28">Legal <br>Information</h1>
      <p class="font-poppins text-white text-xl max-w-sm">Everything you need in one place.</p>
    </div>
  </div>

  <div class="bg-white">
    <div class="pl-4 lg:pl-20 py-14 font-poppins">
      <div>
        <p class="mb-5">Please find the following legal documents below:</p>
        <div class="grid grid-cols-2 lg:grid-cols-4">
          <div class="col-span-1" v-if="legalDocuments.termsOfService.length > 0">
            <h3 class="text-2xl mb-5 font-bold">Terms Of Service</h3>
            <p class="mb-5" v-for="legalDocument in legalDocuments.termsOfService" :key="legalDocument.name"><a :href="legalDocument.url" class="text-black hover:text-black hover:underline transition duration-250" target="_blank">{{legalDocument.name}}</a></p>
            <h3 class="text-2xl mb-5 font-bold">Critical Information Summaries</h3>
            <p class="mb-5" v-for="cis in legalDocuments.cis" :key="cis.name"><a :href="cis.url" class="text-black hover:text-black hover:underline transition duration-250" target="_blank">{{cis.name}}</a></p>

            <router-link to="/legacy" class="text-xl mb-5 font-bold underline text-brand-secondary">
              Legacy Documents
            </router-link>
          </div>
          <div class="col-span-1" v-if="legalDocuments.policies.length > 0">
            <h3 class="text-2xl mb-5 font-bold">Policies</h3>
            <p class="mb-5" v-for="legalDocument in legalDocuments.policies" :key="legalDocument.name"><a :href="legalDocument.url" class="text-black hover:text-black hover:underline transition duration-250" target="_blank">{{legalDocument.name}}</a></p>
          </div>
          <div class="col-span-1" v-if="legalDocuments.formsAndGuides.length > 0">
            <h3 class="text-2xl mb-5 font-bold">Forms & Guides</h3>
            <p class="mb-5" v-for="legalDocument in legalDocuments.formsAndGuides" :key="legalDocument.name"><a :href="legalDocument.url" class="text-black hover:text-black hover:underline transition duration-250" target="_blank">{{legalDocument.name}}</a></p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();
</script>
<style scoped>
.bg-legal {
  background-repeat: no-repeat;
  background-color: transparent;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/legal-bg.png");
  background-position: center center;
  background-size: cover;
  height: 100%;
}
</style>
